// extracted by mini-css-extract-plugin
export default {"input":"fileInput_input__L0EdS","small":"fileInput_small__ZVjcF"};